(function () {
  'use strict';
  var hero = document.querySelector('[data-elvi-hero]');
  if (!hero) return;
  var lamp = hero.querySelector('[data-elvi-lamp]');
  if (!lamp) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var L = 178;
  var w = hero.clientWidth || 1000;
  var x = w / 2, tx = w / 2, ang = 0, vang = 0, last = 0;
  var pointer = false, active = -1e9, running = false;

  function paint() {
    var rad = ang * Math.PI / 180;
    var bx = x - Math.sin(rad) * L;
    var by = Math.cos(rad) * L;
    var r = hero.getBoundingClientRect();
    lamp.style.transform = 'translateX(' + (x - w / 2) + 'px) rotate(' + ang + 'deg)';
    hero.style.setProperty('--mx', bx + 'px');
    hero.style.setProperty('--my', by + 'px');
    hero.style.setProperty('--cx', (r.left + bx) + 'px');
    hero.style.setProperty('--cy', (r.top + by) + 'px');
  }

  function frame(t) {
    if (!running) return;
    var dt = Math.min(32, last ? t - last : 16);
    last = t;
    if (!pointer && t - active > 2500) tx = w / 2 + Math.sin(t / 2600) * w * 0.22;
    var prev = x;
    x += (tx - x) * Math.min(1, dt * 0.004);
    var v = (x - prev) / Math.max(dt, 1);
    var target = Math.max(-16, Math.min(16, v * -10));
    vang += (-0.00015 * (ang - target) - 0.006 * vang) * dt;
    ang += vang * dt;
    paint();
    requestAnimationFrame(frame);
  }

  function start() { if (running || reduce) return; running = true; last = 0; requestAnimationFrame(frame); }
  function stop() { running = false; }

  hero.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch') return;
    pointer = true; active = performance.now();
    var r = hero.getBoundingClientRect();
    tx = Math.max(48, Math.min(r.width - 48, e.clientX - r.left));
  });
  hero.addEventListener('pointerleave', function () { pointer = false; active = performance.now(); });
  window.addEventListener('resize', function () { w = hero.clientWidth || w; if (reduce) { x = w / 2; paint(); } });
  window.addEventListener('scroll', function () { if (!running) paint(); }, { passive: true });

  lamp.addEventListener('click', function () {
    var on = hero.getAttribute('data-on') !== 'true';
    hero.setAttribute('data-on', on ? 'true' : 'false');
    lamp.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }).observe(hero);
  } else { start(); }
  paint();
})();